import React from 'react';

interface IExpectedDeliveryDateEmptyViewProps {
    image: string;
    title?: string;
    subtitle?: string;
    additionalText?: React.ReactNode;
}

export const ExpectedDeliveryDateEmptyView = ({ image, title, subtitle, additionalText }: IExpectedDeliveryDateEmptyViewProps) => {
    return (
        <div className="ExpectedDeliveryDateEmptyView">
            {image && <img src={image} alt={title} className="ExpectedDeliveryDateEmptyView__Image" />}
            {title && <span className="ExpectedDeliveryDateEmptyView__Title">{title}</span>}
            {subtitle && <span className="ExpectedDeliveryDateEmptyView__Subtitle">{subtitle}</span>}
            {additionalText && <span className="ExpectedDeliveryDateEmptyView__AdditionalText">{additionalText}</span>}
        </div>
    );
};
